export function userHasPerm(user, perm) {
  return user?.permissions?.includes(perm)
}
